import { el } from "./dom.js";

// A transient bottom toast with an optional action (e.g. "Undo"). Only one is
// shown at a time — a new toast replaces any current one.
let current = null;

export function showToast(message, { actionLabel, onAction, durationMs = 5000 } = {}) {
	dismiss();

	const toast = el("div.toast", {}, el("span.toast__msg", {}, message));
	if (actionLabel && onAction) {
		toast.append(
			el(
				"button.toast__action",
				{
					type: "button",
					onclick: async () => {
						dismiss();
						await onAction();
					},
				},
				actionLabel,
			),
		);
	}

	document.body.appendChild(toast);
	const timer = setTimeout(dismiss, durationMs);
	current = { toast, timer };
	return toast;
}

export function dismiss() {
	if (!current) return;
	clearTimeout(current.timer);
	current.toast.remove();
	current = null;
}
